import { Box, IconButton } from '@material-ui/core';
import { Tooltip } from 'antd';
import React from 'react';
import { useTranslate } from 'react-admin';
import { Edit } from '@material-ui/icons';
import { useGetNoPageListData } from '../../../../base/components/customized/CustomizedNoPageList';
import resourceSlug from '../../../../constant/resource-slug';
import UpdateAdjustmentModal from '../UpdateAdjustmentModal';

const AdjustInvoiceButton = ({ record }) => {
  const t = useTranslate();
  const { refetchListData } = useGetNoPageListData(resourceSlug.INVOICE);

  return (
    <UpdateAdjustmentModal
      invoiceNo={record?.invoiceNo}
      invoiceId={record?.id}
      amount={record?.adjustment?.amount}
      description={record?.adjustment?.description}
      currencyCode={record?.currencyCode}
      totalInvoiceAmount={record?.invoiceAmount}
      trigger={
        <Tooltip title={t('resources.invoice.adjustInvoice')}>
          <Box component={IconButton} size="small" minWidth={30}>
            <Edit fontSize="small" />
          </Box>
        </Tooltip>
      }
      onSuccess={() => {
        refetchListData();
      }}
    />
  );
};

export default AdjustInvoiceButton;
